import React from 'react';
import { EmptyStateDescription, EmptyStateIcon, EmptyStateStyled, EmptyStateTitle, } from './empty-state.component.style';
export var EmptyState = function (_a) {
    var icon = _a.icon, title = _a.title, description = _a.description;
    return (React.createElement(EmptyStateStyled, null,
        icon && React.createElement(EmptyStateIcon, { "aria-hidden": "true" }, icon),
        React.createElement(EmptyStateTitle, null, title),
        description && React.createElement(EmptyStateDescription, null, description)));
};
